import { useEffect, useState, useCallback } from "react";
import { fetchMessagesForDiscussion } from "../services/messages";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";
// Déjà dans le hook — ajoute juste cette fonction exportée
export async function getLastMessage(discussionId, messagesCache, setMessagesCache) {
  if (messagesCache[discussionId]) {
    const msgs = messagesCache[discussionId];
    return msgs[msgs.length - 1] || null;
  }
  try {
    const msgs = await fetchMessagesForDiscussion(discussionId);
    setMessagesCache(prev => ({ ...prev, [discussionId]: msgs }));
    return msgs[msgs.length - 1] || null;
  } catch {
    return null;
  }
}

export default function usePreloadDiscussions(discussions) {
  const [messagesCache, setMessagesCache] = useState({});
  const [loading, setLoading] = useState(false);

  // 🔹 Précharge les messages des N dernières discussions
 useEffect(() => {
  if (!discussions || discussions.length === 0) return;

  const maxPreload = 3;
  const discussionsToPreload = discussions.slice(0, maxPreload);

  const preload = async () => {
    setLoading(true);
    await Promise.all(
      discussionsToPreload.map(async (discussion) => {
        if (!messagesCache[discussion._id]) {
          try {
            const msgs = await fetchMessagesForDiscussion(discussion._id);
            setMessagesCache(prev => ({ ...prev, [discussion._id]: msgs }));
          } catch (err) {
            console.error("Erreur préchargement messages :", err);
          }
        }
      })
    );
    setLoading(false); // ✅ exécuté seulement quand tout est fini
  };

  preload();
}, [discussions]);

  // 🔹 Précharge les images de profil
  useEffect(() => {
    if (!discussions || discussions.length === 0) return;

    const urls = discussions
      .map(d => 
        d.creator?.profileImage
          ? `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${d.creator._id}?token=${localStorage.getItem('token')}&type=image&thumb=true&profile=true&t=${d.creator.profileImageUpdatedAt || 0}`
          : `${API_URL}/uploads/default-profile.png`
      );

    urls.forEach(url => {
      const img = new Image();
      img.src = url; // le navigateur va automatiquement mettre en cache
    });
  }, [discussions]);

 // ← NOUVEAU : permet à DiscussionList de mettre à jour le cache
  // après une synchro en arrière-plan
  const updateCache = useCallback((discussionId, messages) => {
    setMessagesCache(prev => ({ ...prev, [discussionId]: messages }));
  }, []);


return { messagesCache, setMessagesCache, loading };
}
